<app-header></app-header>

<div class="container-fluid p-4">

  <!-- Loading -->
  <div *ngIf="carregando" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
    <p class="mt-2 text-muted">Carregando dashboard...</p>
  </div>

  <!-- Erro -->
  <div *ngIf="erro && !carregando" class="alert alert-danger d-flex align-items-center" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    <span>{{ erro }}</span>
  </div>

  <ng-container *ngIf="!carregando && !erro">

    <!-- ═══ CARDS DE MÉTRICAS ═══ -->
    <div class="row g-3 mb-4">

      <!-- Total de Itens — REAL -->
      <div class="col-md-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0">
          <div class="card-body d-flex justify-content-between align-items-center py-4">
            <div>
              <p class="text-muted small mb-1 text-uppercase fw-semibold"
                style="font-size:.72rem; letter-spacing:.05em;">Total de Itens</p>
              <h3 class="mb-0 fw-bold">{{ totalItens | number }}</h3>
            </div>
            <div class="bg-primary bg-opacity-10 rounded-circle p-3">
              <i class="bi bi-box-seam text-primary fs-4"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Itens Ativos — REAL (ativo === true) -->
      <div class="col-md-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0">
          <div class="card-body d-flex justify-content-between align-items-center py-4">
            <div>
              <p class="text-muted small mb-1 text-uppercase fw-semibold"
                style="font-size:.72rem; letter-spacing:.05em;">Itens Ativos</p>
              <h3 class="mb-0 fw-bold">{{ itensAtivos | number }}</h3>
            </div>
            <div class="bg-success bg-opacity-10 rounded-circle p-3">
              <i class="bi bi-check-circle text-success fs-4"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Itens em Uso — Em breve -->
      <div class="col-md-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 border-secondary-subtle">
          <div class="card-body d-flex justify-content-between align-items-center py-4">
            <div>
              <p class="text-muted small mb-1 text-uppercase fw-semibold"
                style="font-size:.72rem; letter-spacing:.05em;">Itens em Uso</p>
              <div class="d-flex align-items-center gap-2">
                <h3 class="mb-0 fw-bold text-muted">—</h3>
                <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
                  style="font-size:.62rem;">Em breve</span>
              </div>
            </div>
            <div class="bg-info bg-opacity-10 rounded-circle p-3">
              <i class="bi bi-laptop text-info fs-4"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Solicitações Pendentes — Em breve -->
      <div class="col-md-6 col-lg-3">
        <div class="card shadow-sm h-100 border-0 border-secondary-subtle">
          <div class="card-body d-flex justify-content-between align-items-center py-4">
            <div>
              <p class="text-muted small mb-1 text-uppercase fw-semibold"
                style="font-size:.72rem; letter-spacing:.05em;">Solicitações Pendentes</p>
              <div class="d-flex align-items-center gap-2">
                <h3 class="mb-0 fw-bold text-muted">—</h3>
                <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
                  style="font-size:.62rem;">Em breve</span>
              </div>
            </div>
            <div class="bg-warning bg-opacity-10 rounded-circle p-3">
              <i class="bi bi-inbox text-warning fs-4"></i>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- ═══ LINHA 1: 3 GRÁFICOS ═══ -->
    <div class="row g-4 mb-4">

      <!-- Distribuição por Status — REAL -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold">Distribuição por Status</div>
          <div class="card-body" style="height: 300px;">
            <div *ngIf="!temDistribuicao"
              class="h-100 d-flex flex-column align-items-center justify-content-center text-muted">
              <i class="bi bi-bar-chart" style="font-size:2.5rem; opacity:.4;"></i>
              <p class="mt-2 mb-0 small">Sem dados disponíveis</p>
            </div>
            <canvas *ngIf="temDistribuicao" baseChart [data]="distribuicaoChartData"
              [options]="distribuicaoChartOptions" chartType="bar">
            </canvas>
          </div>
        </div>
      </div>

      <!-- Marcas Mais Usadas — REAL (calculado dos itens) -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold">Marcas Mais Usadas</div>
          <div class="card-body" style="height: 300px;">
            <div *ngIf="!temMarcas"
              class="h-100 d-flex flex-column align-items-center justify-content-center text-muted">
              <i class="bi bi-bar-chart-line" style="font-size:2.5rem; opacity:.4;"></i>
              <p class="mt-2 mb-0 small">Sem dados disponíveis</p>
            </div>
            <canvas *ngIf="temMarcas" baseChart [data]="marcasChartData" [options]="marcasChartOptions" chartType="bar">
            </canvas>
          </div>
        </div>
      </div>

      <!-- Solicitações Pendentes por Tipo — Em breve -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold d-flex justify-content-between align-items-center">
            Solicitações Pendentes por Tipo
            <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
              style="font-size:.62rem;">Em breve</span>
          </div>
          <div class="card-body h-100 d-flex flex-column align-items-center justify-content-center text-muted"
            style="height:300px;">
            <i class="bi bi-hourglass-split" style="font-size:2.5rem; opacity:.4;"></i>
            <p class="mt-2 mb-0 small text-center">Módulo de solicitações<br>ainda não integrado.</p>
          </div>
        </div>
      </div>

    </div>

    <!-- ═══ LINHA 2: ATIVIDADES + TABELA ═══ -->
    <div class="row g-4 mb-4">

      <!-- Atividades Recentes — baseado nos últimos cadastros reais -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold">Atividades Recentes</div>
          <div *ngIf="!itensRecentes.length"
            class="card-body d-flex flex-column align-items-center justify-content-center text-muted">
            <i class="bi bi-inbox" style="font-size:2.5rem; opacity:.4;"></i>
            <p class="mt-2 mb-0 small">Sem atividades registradas.</p>
          </div>
          <ul class="list-group list-group-flush" *ngIf="itensRecentes.length">
            <li class="list-group-item d-flex align-items-start gap-3 py-3" *ngFor="let a of itensRecentes">
              <div class="mt-1">
                <span class="d-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle"
                  style="width:32px; height:32px;">
                  <i class="bi bi-check-circle-fill text-success" style="font-size:.95rem;"></i>
                </span>
              </div>
              <div>
                <span class="d-block small">{{ a.description }}</span>
                <span class="text-muted" style="font-size:.75rem;">{{ a.time }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Itens Desligados — Em breve -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold d-flex justify-content-between align-items-center">
            Itens por Prof. Desligado
            <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
              style="font-size:.62rem;">Em breve</span>
          </div>
          <div class="card-body h-100 d-flex flex-column align-items-center justify-content-center text-muted">
            <i class="bi bi-person-x" style="font-size:2.5rem; opacity:.4;"></i>
            <p class="mt-2 mb-0 small text-center">Módulo de desligamento<br>ainda não integrado.</p>
          </div>
        </div>
      </div>

      <!-- Solicitações por Colaborador — Em breve -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom fw-semibold d-flex justify-content-between align-items-center">
            Solicitações por Colaborador
            <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
              style="font-size:.62rem;">Em breve</span>
          </div>
          <div class="card-body h-100 d-flex flex-column align-items-center justify-content-center text-muted">
            <i class="bi bi-person-lines-fill" style="font-size:2.5rem; opacity:.4;"></i>
            <p class="mt-2 mb-0 small text-center">Módulo de solicitações<br>ainda não integrado.</p>
          </div>
        </div>
      </div>

    </div>

    <!-- ═══ LINHA 3: TABELA COMPLETA DE ITENS ═══ -->
    <div class="row g-4">
      <div class="col-12">
        <div class="card shadow-sm border-0">
          <div class="card-header bg-white border-bottom fw-semibold">📋 Todos os Itens Cadastrados</div>
          <div class="card-body p-0">
            <div *ngIf="!dashboardData?.itens?.length" class="text-center text-muted py-5">
              <i class="bi bi-inbox" style="font-size:2rem; opacity:.4;"></i>
              <p class="mt-2">Nenhum item cadastrado.</p>
            </div>
            <div class="table-responsive" *ngIf="dashboardData?.itens?.length">
              <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Patrimônio</th>
                    <th>Descrição</th>
                    <th>Categoria</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>Condição</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData!.itens">
                    <td><strong>#{{ item.exbePatrimonioId }}</strong></td>
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.categoria?.nome ?? '—' }}</td>
                    <td>{{ item.marca?.nome ?? '—' }}</td>
                    <td>{{ item.modelo?.nome ?? '—' }}</td>
                    <td>
                      <span class="badge rounded-pill" [class.bg-success]="item.tipoCondicaoBens?.nome === 'Novo'"
                        [class.bg-info]="item.tipoCondicaoBens?.nome === 'Bom'"
                        [class.bg-warning]="item.tipoCondicaoBens?.nome === 'Danificado'"
                        [class.bg-danger]="item.tipoCondicaoBens?.nome === 'Perdido'"
                        [class.bg-secondary]="!item.tipoCondicaoBens?.nome">
                        {{ item.tipoCondicaoBens?.nome ?? 'N/A' }}
                      </span>
                    </td>
                    <td>
                      <span class="badge rounded-pill" [class.bg-success-subtle]="item.ativo"
                        [class.text-success-emphasis]="item.ativo" [class.bg-secondary-subtle]="!item.ativo"
                        [class.text-secondary-emphasis]="!item.ativo">
                        {{ item.ativo ? 'Ativo' : 'Inativo' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>
</div>